import { useEffect } from "react";

const SUFFIX = "ViaMenu — Seu Cardápio Digital";

export function useDocumentTitle(title?: string) {
  useEffect(() => {
    if (title) {
      document.title = `${title} - ${SUFFIX}`;
    } else {
      document.title = SUFFIX;
    }
    return () => {
      document.title = SUFFIX;
    };
  }, [title]);
}
